import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class FileValidators {
  public static maxSize(maxSize: number): ValidatorFn {
    const validatorFn = (file: File): object | null => {
      if (file instanceof File && file.size > maxSize) {
        return { file, maxSize, actualSize: file.size };
      }

      return null;
    };

    return FileValidators.validation(validatorFn, 'fileMaxSize');
  }

  public static allowedExtensions(allowedExtensions: string[]): ValidatorFn {
    const validatorFn = (file: File): object | null => {
      if (allowedExtensions.length === 0) {
        return null;
      }

      if (file instanceof File) {
        if (file.name.indexOf('.') === -1) {
          return { file, allowedExtensions, actualExtension: '' };
        }
        const extension: string = file.name.split('.').pop() as string;
        if (
          !extension ||
          (extension && allowedExtensions.indexOf(extension.toLowerCase()) === -1)
        ) {
          return { file, allowedExtensions, actualExtension: extension };
        }
      }

      return null;
    };

    return FileValidators.validation(validatorFn, 'fileAllowedExtensions');
  }

  public static filenameMaxLength(maxLength: number): ValidatorFn {
    const validatorFn = (file: File): object | null => {
      if (file instanceof File && file.name.length > maxLength) {
        return { file, maxLength, actualLength: file.name.length };
      }

      return null;
    };

    return FileValidators.validation(validatorFn, 'filenameMaxLength');
  }

  public static filenamePattern(regex?: RegExp): ValidatorFn {
    // Exclude & => (?!.*[&])
    // Allow all ASCII valid characters => \x00-\x7F
    // Allow french characters => àâçéèêæœ
    const validName = regex || /^(?!.*[&])[\x00-\x7Fàâçéèêæœ]+$/;

    const validatorFn = (file: File): object | null => {
      if (file instanceof File && !validName.test(file.name)) {
        return { file, actualName: file.name };
      }

      return null;
    };
    return FileValidators.validation(validatorFn, 'filenamePattern');
  }

  public static validation(
    validatorFn: (file: File) => object | null,
    validatorName: string,
  ): ValidatorFn {
    return (formControl: AbstractControl): ValidationErrors | null => {
      if (!formControl.value) {
        return null;
      }

      if (Array.isArray(formControl.value)) {
        const errors = formControl.value.map((file: File) => validatorFn(file)).filter((i) => i);
        if (errors.length) {
          return { [validatorName]: errors };
        }
      } else {
        const error = validatorFn(formControl.value);
        if (error) {
          return { [validatorName]: error };
        }
      }

      return null;
    };
  }
}
